export enum ChartActionTypes {
  GET_CHART_DATA = "@@CHART/GET_CHART_DATA",
  GET_CHART_DATA_SUCCESS = "@@CHART/GET_CHART_DATA_SUCCESS",
  GET_CHART_DATA_FAILURE = "@@CHART/GET_CHART_DATA_FAILURE",
}
